import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initItemcardVideo() {
    const videoContainer = document.querySelector('.itemcardEilaTopVideo');
    const videoElement = videoContainer?.querySelector('video');

    if (!videoElement || !videoContainer) {
        return;
    }

    if(window.innerWidth < 768){
        videoElement.autoplay = true;
        videoElement.muted = true;
        videoElement.playsInline = true;
        videoElement.loop = true;
        videoElement.play();
        return;
    }

    videoElement.pause();

    const itemcardTop = videoContainer.closest('.itemcardEilaTop');

    if(!itemcardTop){
        return;
    }

    let scrollTriggersInitialized = false;

    const once = (el, event, fn) => {
        const onceFn = function(e) {
            el.removeEventListener(event, onceFn);
            fn.apply(this, arguments);
        };
        el.addEventListener(event, onceFn);
        return onceFn;
    };

    // iOS Video Aktivierung
    once(document.documentElement, 'touchstart', () => {
        videoElement.play();
        videoElement.pause();
    });

    const initScrollTrigger = () => {
        if (scrollTriggersInitialized) {
            return;
        }

        const videoDuration = videoElement.duration;
        if (!videoDuration || isNaN(videoDuration) || videoDuration === 0) {
            return;
        }

        scrollTriggersInitialized = true;

        // Video scrubbing timeline
        const tl = gsap.timeline({
            defaults: { duration: 1 },
            scrollTrigger: {
                trigger: itemcardTop,
                start: 'top top',
                end: 'bottom bottom',
                scrub: true
            }
        });

        tl.fromTo(
            videoElement,
            { currentTime: 0 },
            { currentTime: videoDuration }
        );

        // Sticky scroll effect for video container
        ScrollTrigger.create({
            trigger: itemcardTop,
            start: 'top top',
            end: 'bottom bottom',
            pin: videoContainer,
            pinSpacing: false
        });
    };

    if (videoElement.readyState >= 4) {
        initScrollTrigger();
    } else {
        videoElement.addEventListener('canplaythrough', initScrollTrigger);
    }

    if (videoElement.readyState === 0) {
        videoElement.load();
    }
}